__turbopack_context__.v({
  "image": "Stamp-module__5SWtYW__image",
  "none": "Stamp-module__5SWtYW__none",
  "shapeCircular": "Stamp-module__5SWtYW__shapeCircular",
  "shapeSquare": "Stamp-module__5SWtYW__shapeSquare",
  "sizeLarge": "Stamp-module__5SWtYW__sizeLarge",
  "sizeMedium": "Stamp-module__5SWtYW__sizeMedium",
  "sizeMini": "Stamp-module__5SWtYW__sizeMini",
  "sizeSmall": "Stamp-module__5SWtYW__sizeSmall",
  "sizeXLarge": "Stamp-module__5SWtYW__sizeXLarge",
  "sizeXSmall": "Stamp-module__5SWtYW__sizeXSmall",
  "stamp": "Stamp-module__5SWtYW__stamp",
});
